import * as React from "react";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import { RadioGroup, Radio, Dialog } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import images from "../../../global-styles/images";
import { appLogger } from "../../../utils";

const Item = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  // padding: theme.spacing(1),
  color: theme.palette.text.secondary,
  boxShadow: "none",
  background: "none",
}));

import "./PreviewStyles/index.css";

const MobileFeedbackSuccess = (props: any) => {
  appLogger.info({
    infoObj: {
      method: "FeedbackSettingsPreview",
      component: "add-product",
      fileName: "FeedbackSettingsPreview.tsx",
      props: props,
    },
  });
  const { productParams } = props;
  const [checked, setChecked] = React.useState([0]);
  const [StdFbscontent, setStdFbscontent] = React.useState<any>("");
  const [selectedCat, setselectedCat] = React.useState<any>("");
  const [PreviewZoom, setPreviewZoom] = React.useState<any>("zoomout");

  const [previewAgent, setPreviewAgent] = React.useState(false);

  const handleTogglePreview = () => {
    setPreviewAgent((prevState) => !prevState);
  };

  const handleToggle = (value: number) => () => {
    const currentIndex = checked.indexOf(value);

    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };

  const FdSettingsRatingStar = () => {
    return (
      productParams.productParams.products[0].feedbackAgentSettings
        ?.feedbackSettings?.ratingLimit || 0
    );
  };
  const FdSettingsrequireEmail = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.requireEmail == true
      ? "(required)"
      : "(optional)";
  };
  const GenSettingsFbcategoryHeading = () => {
    return (
      productParams.productParams.products[0].feedbackAgentSettings
        ?.feedbackSettings?.categoryHeading || ""
    );
  };
  const FdSettingsrequireCategory = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.feedbackSettings?.reqCategory == true
      ? "(required)"
      : "(optional)";
  };
  const FdSettingsCategories = () => {
    let content: any = "";
    if (
      productParams.productParams.products[0].feedbackAgentSettings
        ?.feedbackSettings?.categories?.length > 0
    ) {
      content = (
        <>
          <Grid sx={{ mt: 1 }} className="category-list-wrap">
            {/* <InputLabel
              id="demo-simple-select-label"
              sx={{ mb: 0.2, fontSize: 12 }}
            >
              {` ${GenSettingsFbcategoryHeading()} ${FdSettingsrequireCategory()}`}
            </InputLabel> */}

            <Typography className="preview-title">
              What experience would you like to provide feedback about?
            </Typography>

            <FormControl sx={{ mt: 1 }}>
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                defaultValue=""
                name="radio-buttons-group"
              >
                {productParams.productParams.products[0].feedbackAgentSettings?.feedbackSettings?.categories.map(
                  (val: any, index: any) => (
                    <FormControlLabel
                      value={val.name}
                      label={val.name}
                      control={<Radio />}
                    />
                  )
                )}
              </RadioGroup>
            </FormControl>
          </Grid>
        </>
      );
    }
    return content;
  };
  const CatFbStdFeedbacks = (checkName: any) => {
    let content: any = "";
    if (
      productParams.productParams.products[0].feedbackAgentSettings
        ?.feedbackSettings?.categories?.length > 0
    ) {
      productParams.productParams.products[0].feedbackAgentSettings?.feedbackSettings?.categories.map(
        (val: any, index: any) => {
          if (val.feedbacks.length > 0 && val.name == checkName) {
            content = (
              <List
                sx={{
                  width: "100%",
                  maxWidth: 360,
                  ml: 0.5,
                  bgcolor: "background.paper",
                }}
              >
                {val.feedbacks.map((value: any) => {
                  const labelId = `checkbox-list-label-${value}`;
                  return (
                    <ListItem
                      key={value}
                      secondaryAction={
                        <IconButton
                          edge="end"
                          aria-label="comments"
                        ></IconButton>
                      }
                      disablePadding
                    >
                      <Checkbox
                        className="fdstdfeedbackscheck"
                        // onClick={handleToggle(value)}
                        edge="start"
                        checked={checked.includes(value)}
                        tabIndex={-1}
                        disableRipple
                        inputProps={{ "aria-labelledby": labelId }}
                      />
                      <ListItemText
                        className="agent-fb-catelist-text"
                        id={labelId}
                        primary={`${value}`}
                      />
                    </ListItem>
                  );
                })}
              </List>
            );
          }
        }
      );
    }
    setStdFbscontent(content);
    // return content
  };

  const GenSettingsFbCommentsHeading = () => {
    return (
      productParams.productParams.products[0].feedbackAgentSettings
        ?.feedbackSettings?.generalCommentsHeading || ""
    );
  };
  const GenSettingsFbCommentreqComments = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.feedbackSettings?.reqComments == true
      ? " (required)"
      : " (optional)";
  };
  const FbTopdialogMsg = () => {
    return (
      productParams.productParams.products[0].feedbackAgentSettings
        ?.feedbackSettings?.dialogMsg || ""
    );
  };
  const renderGeneralSettingsMainTitle = () => {
    return (
      productParams.productParams.products[0].feedbackAgentSettings?.title || ""
    );
  };
  const Mainlogo = () => {
    return productParams.productParams.products[0]?.logo;
  };

  const handleCatChange = (event: any) => {
    setselectedCat(event.target.value);
    productParams.productParams.products[0].feedbackAgentSettings?.feedbackSettings?.categories.map(
      (val: any, index: any) => {
        if (val.name == event.target.value) {
          CatFbStdFeedbacks(event.target.value);
        }
      }
    );
  };
  React.useEffect(() => {
    if (
      productParams.productParams.products[0].feedbackAgentSettings
        ?.feedbackSettings?.categories?.length == 1
    ) {
      setselectedCat(
        productParams.productParams.products[0].feedbackAgentSettings
          ?.feedbackSettings?.categories[0].name
      );
      CatFbStdFeedbacks(
        productParams.productParams.products[0].feedbackAgentSettings
          ?.feedbackSettings?.categories[0].name
      );
    } else {
      setselectedCat("");
      setStdFbscontent("");
    }
  }, [
    productParams.productParams.products[0].feedbackAgentSettings
      ?.feedbackSettings?.categories?.length,
  ]);

  const fullscreenchanged = (event: any) => {
    // document.fullscreenElement will point to the element that
    // is in fullscreen mode if there is one. If not, the value
    // of the property is null.
    if (document.fullscreenElement) {
      setPreviewZoom("zoomin");
    } else {
      setPreviewZoom("zoomout");
    }
  };

  const el: any = document.getElementById("fullscreen-div");
  const tt: any = document.getElementById("toggle-fullscreen");

  if (el != null) {
    el.addEventListener("fullscreenchange", fullscreenchanged);
    // or
    el.onfullscreenchange = fullscreenchanged;
  }

  if (tt != null) {
    // When the toggle button is clicked, enter/exit fullscreen

    tt.addEventListener("click", (event: any) => {
      if (document.fullscreenElement) {
        // exitFullscreen is only available on the Document object.
        document.exitFullscreen();
      } else {
        el.requestFullscreen();
      }
    });
  }
  const zoomClick = () => (event: any) => {
    const fullscreendiv: any = document.getElementById("fullscreen-success");
    if (document.fullscreenElement) {
      setPreviewZoom("zoomout");
      // exitFullscreen is only available on the Document object.
      document.exitFullscreen();
    } else {
      fullscreendiv.requestFullscreen();
      setPreviewZoom("zoomin");
    }
  };

  const renderContent = () => {
    return (
      <Grid
        container
        sx={{
          mt: 1,
          p: 2,
          border: "1px solid #dbdce0",
          borderRadius: "35px",
          padding: "45px 10px 20px 10px",
          background: "#000",
          // boxShadow:
          //   "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px",
        }}
      >
        <Grid
          container
          alignItems="center"
          sx={{
            background: "#0157FF",
            borderRadius: "20px 20px 0 0",
            padding: "10px 12px",
          }}
        >
          <CloseIcon sx={{ color: "#fff", fontSize: "16px" }} />
          <Typography
            sx={{ color: "#fff", fontSize: "13px", marginLeft: "7px" }}
          >
            Share Feedback
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          md={12}
          sx={{
            padding: "10px 12px 0",
            height: previewAgent ? "600px" : "390px",
            overflow: "auto",
            background: "#fff",
            borderRadius: "0 0 15px 15px",
            display: "flex",
            flexDirection: "column",
            "&::-webkit-scrollbar": {
              display: "none",
              "-ms-overflow-style": "none",
              scrollbarWidth: "none",
            },
          }}
        >
          <Grid
            container
            flexDirection="column"
            item
            xs={12}
            justifyContent="center"
            textAlign="center"
          >
            <img
              src={images.success}
              alt="Success"
              style={{ width: "160px", margin: "0 auto" }}
            />

            <Typography
              sx={{
                fontSize: "14px",
                fontWeight: 700,
                lineHeight: "24px",
                marginBottom: "5px",
              }}
            >
              Thank you for sharing.
            </Typography>
            <Typography
              sx={{
                color: "#04000080",
                fontSize: "11px",
                fontWeight: 500,
                lineHeight: "20px",
                marginBottom: "20px",
              }}
            >
              {
                props.productParams.productParams.products[0]
                  .feedbackAgentSettings.feedbackSettings.thanksMsg
              }
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    );
  };

  return (
    <>
      <Typography className="prev-text-titile">
        Feedback Settings: Preview &nbsp;
      </Typography>
      {!previewAgent && (
        <Grid container justifyContent="center" mt={1} mb={1}>
          <Typography
            className="tv-agent-preview-btn guideTourViewActualSize"
            onClick={handleTogglePreview}
            sx={{ color: "#0157FF", fontSize: 12 }}
          >
            Click to preview actual size
          </Typography>
        </Grid>
      )}
      <div style={{ marginTop: "20px" }}>{renderContent()}</div>
      {previewAgent && (
        <Dialog
          open={previewAgent}
          onClose={handleTogglePreview}
          sx={{
            "& .MuiPaper-root": {
              // borderRadius: "20px",
              // maxWidth: "390px",
              // minWidth: "390px",
              // minHeight: "700px",
              // maxHeight: "844px",
              background: "transparent",
              boxShadow: "none",
              "&::-webkit-scrollbar": {
                display: "none",
                "-ms-overflow-style": "none",
                scrollbarWidth: "none",
              },
              overflow: "inherit",
              position: "relative",
            },
            "& .MuiBackdrop-root": {
              backgroundColor: "#808080",
            },
            maxWidth: "390px",
            maxHeight: "844px",
            margin: "auto",
          }}
        >
          {previewAgent && (
            <Typography className="mobile-agent-preview-close">
              For Preview
              <span onClick={handleTogglePreview} className="prevclose">
                &nbsp; x &nbsp;Close&nbsp;
              </span>
            </Typography>
          )}
          {renderContent()}
        </Dialog>
      )}
    </>
  );
};

export default MobileFeedbackSuccess;
